import React, { useEffect, useState, useCallback } from 'react'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'
import FooterServices from '../../services/footer.service'
import Loading from 'custom/assets/loaders/Loading'
import { useTranslation } from 'react-i18next'
import { TERMS_CONDITIONS_KEYS } from '../../utils/translation-constants'

export default function TC() {
  const [dataSource, setDataSource] = useState({})
  const [stage, setStage] = useState(0)
  const { t } = useTranslation()

  const fetchTermsAndConditions = useCallback(
    async (data) => {
      try {
        setStage(0)
        const response = await FooterServices.getTcDetails({ module: 'GENERAL' })

        if (response.data['termsCondition']) {
          setDataSource(response.data['termsCondition'][0])
        }
        setStage(1)
      } catch (err) {}
    },
    [],
  )

  useEffect(() => {
    fetchTermsAndConditions()
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderTermsConditions()
      default:
        return renderLoading()
    }
  }

  function renderTermsConditions() {
    return (
      <div className=''>
        <h4 className='heading-style' style={{textAlign:'center',fontSize:25}}>{t(TERMS_CONDITIONS_KEYS.HEADER)}</h4>
        <div>
          <p
            dangerouslySetInnerHTML={{ __html: dataSource?.message || '' }}
            className='text-justify '
            style={{ height: 300, padding: 20, overflow: 'overlay', whiteSpace: 'pre-line' }}></p>
        </div>
      </div>
    )
  }

  function renderLoading() {
    return (
      <div className='d-flex flex-column text-center'>
        <div className='my-4'>
          <Loading width='50px' height='50px' />
        </div>
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard
      breadCumKey='TERMS AND CONDITIONS'
      showEmptySpace={false}
      keyPath={'TERMS_AND_CONDITIONS'}>
      <div>{renderSwitch()}</div>
    </LayoutWithOutAccountCard>
  )
}
